// extracted by mini-css-extract-plugin
module.exports = {"priceUpdate":"_6a99146"};